export default {"src":"/_next/static/media/ic-tiktok-colorized.3ec2bd70.svg","height":399,"width":399};